import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';
import { useNodeContext } from '../../../../../context/node-context';

const MoveFileTaskForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id: _id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="moveFileTaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="moveFileTaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="moveFileTaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="moveFile"
      />
      <FormField
        controlId="moveFileTaskFormCredentials"
        label="credentials"
        name="parameters.credentials"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter credentials"
        error={errors.parameters?.credentials?.message}
      />
      <FormField
        controlId="moveFileTaskFormPort"
        label="port"
        name="parameters.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter port"
        error={errors.parameters?.port?.message}
      />
      <FormField
        controlId="moveFileTaskFormSource"
        label="source"
        name="parameters.source"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter source path"
        required
        error={errors.parameters?.source?.message}
      />
      <FormField
        controlId="moveFileTaskFormTarget"
        label="target"
        name="parameters.target"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter target path"
        required
        error={errors.parameters?.target?.message}
      />
      <FormField
        controlId="moveFileTaskFormResult"
        label="result"
        name="parameters.result"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter result"
        error={errors.parameters?.result?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default MoveFileTaskForm;
